// extracted by mini-css-extract-plugin
export default {"app_container":"MicroAppDetail_app_container__CvSpL","fadeIn":"MicroAppDetail_fadeIn__SrFAN"};